<script>
import TermsOfService from './TermsOfService.vue'

export default {
    name: 'TermsOfServiceLink',
    components: {
        TermsOfService
    },
    props: {
        el: {
            type: String,
            default: 'div'
        },
        size: {
            type: String,
            default: 'sm'
        },
        text: {
            type: String,
            required: false
        }
    },
    computed: {},
    methods: {},
}
</script>

<template>
    <component :is="el">
        <a v-if="text" @click="$refs.tosModal.show()" href="javascript:{}">{{ text }}</a>
        <span v-else>Durch die Nutzung dieses Dienstes stimmen Sie unseren <a @click="$refs.tosModal.show()" href="javascript:{}">Nutzungsbedingungen &amp; Datenschutzrichtlinie</a> zu</span>
        <!-- Modals -->
        <b-modal ref="tosModal" title="Nutzungsbedingungen &amp; Datenschutzrichtlinie" no-fade centered ok-only>
            <p class="my-2"><terms-of-service /></p>
        </b-modal>
    </component>
</template>